import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  IO365ProjectUsage,
  ISearchO365ProjectUsage,
} from '../../../services/o365/o365ProjectUsage/o365ProjectUsage.model';
import o365ProjectUsageService from '../../../services/o365/o365ProjectUsage/o365ProjectUsage.service';

export const searchO365ProjectUsage = createAsyncThunk(
  'searchO365ProjectUsage',
  async (searchParam?: ISearchO365ProjectUsage) => {
    const response = await o365ProjectUsageService.searchO365ProjectUsage(searchParam).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const getO365ProjectUsageById = createAsyncThunk(
  'getO365ProjectUsageById',
  async (id: number) => {
    const response = await o365ProjectUsageService.getO365ProjectUsageById(id).then((res) => {
      return res.body;
    });
    return response.data;
  }
);

export const saveO365ProjectUsage = createAsyncThunk(
  'saveO365ProjectUsage',
  async (data: IO365ProjectUsage) => {
    const response = await o365ProjectUsageService.saveO365ProjectUsage(data).then((res) => {
      return res.body;
    });
    return response;
  }
);

export const deleteO365ProjectUsage = createAsyncThunk(
  'deleteO365ProjectUsage',
  async (id: number) => {
    const response = await o365ProjectUsageService.deleteO365ProjectUsage(id).then((res) => {
      return res.body;
    });
    return response;
  }
);
